"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GalleryCleanup = exports.Indicator = exports.NavButton = exports.GalleryBody = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));

var _LottieAnimate = _interopRequireDefault(require("../LottieAnimate"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BaseBody = function BaseBody(_ref) {
  var children = _ref.children,
      action = _ref.action;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col w-full bg-card h-70vh 2xl:h-60vh shadow-lg dark:shadow-deep",
    style: {
      maxHeight: 800
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 p-8 overflow-auto"
  }, children), action && /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-10 py-4 shadow-hover dark:shadow-lg-t"
  }, action));
};

var GalleryBody = function GalleryBody(_ref2) {
  var currIdx = _ref2.currIdx,
      total = _ref2.total,
      action = _ref2.action,
      children = _ref2.children,
      onPrevious = _ref2.onPrevious,
      onNext = _ref2.onNext,
      isNext = _ref2.isNext,
      isLoading = _ref2.isLoading;
  var first = currIdx === 0;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-0 w-full h-full",
    style: {
      transform: 'scale(1.08, 0.85)'
    }
  }, !first && /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/2 h-full float-left"
  }, /*#__PURE__*/_react["default"].createElement(GalleryPlaceholder, null)), isNext && /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/2 h-full float-right"
  }, /*#__PURE__*/_react["default"].createElement(GalleryPlaceholder, null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-0 h-full",
    style: {
      width: '130%',
      left: '-15%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement(NavButton, {
    disabled: isLoading,
    className: (0, _classnames["default"])({
      invisible: first
    }),
    onClick: onPrevious
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], {
    fontSize: "large"
  })), /*#__PURE__*/_react["default"].createElement(NavButton, {
    disabled: isLoading,
    className: (0, _classnames["default"])({
      invisible: !isNext
    }),
    onClick: onNext
  }, /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], {
    fontSize: "large"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement(BaseBody, {
    action: action
  }, children)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute bottom-0 w-full -mb-6"
  }, /*#__PURE__*/_react["default"].createElement(Indicator, {
    currIdx: currIdx,
    total: total
  }))));
};

exports.GalleryBody = GalleryBody;

var GalleryPlaceholder = function GalleryPlaceholder() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full bg-card flex items-end"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-16 shadow-hover dark:shadow-lg-t"
  }));
};

var NavButton = function NavButton(_ref3) {
  var children = _ref3.children,
      disabled = _ref3.disabled,
      className = _ref3.className,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["children", "disabled", "className"]);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    disabled: disabled,
    className: (0, _classnames["default"])('p-3 rounded-full bg-app dark:bg-divider text-medium', 'disabled:opacity-50 disabled:cursor-default', {
      'hover:bg-secondary dark:hover:bg-secondary': !disabled
    }, className)
  }), children);
};

exports.NavButton = NavButton;

var Indicator = function Indicator(_ref4) {
  var currIdx = _ref4.currIdx,
      total = _ref4.total;

  if (total === 1 || currIdx >= total) {
    return null;
  }

  function getIndicatorSize(actualIdx, itemIdx, length) {
    var size = 8;

    if (actualIdx < currIdx) {
      if (itemIdx === 0 && actualIdx > 0) {
        size = 4;
      } else if (itemIdx === 1 && actualIdx > 1) {
        size = 6;
      }
    } else if (actualIdx > currIdx) {
      if (itemIdx === length - 1 && total - actualIdx - 1 > 0) {
        size = 4;
      } else if (itemIdx === length - 2 && total - actualIdx - 1 > 1) {
        size = 6;
      }
    }

    return {
      width: size,
      height: size
    };
  }

  function getLeftIndicatorCount() {
    if (total > 6) {
      if (total - currIdx - 1 < 3) {
        return 6 - (total - currIdx - 1);
      } else {
        return Math.min(currIdx, 3);
      }
    } else {
      return currIdx;
    }
  }

  var renderIndicator = function renderIndicator(actualIdx, itemIdx, length) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('rounded-full', {
        'bg-app dark:bg-gray-light': currIdx === actualIdx,
        'bg-gray-light dark:bg-secondary': currIdx !== actualIdx
      }),
      style: _objectSpread({
        margin: 2
      }, getIndicatorSize(actualIdx, itemIdx, length))
    });
  };

  var left = new Array(getLeftIndicatorCount()).fill({}).map(function (_, i, src) {
    return renderIndicator(currIdx - (src.length - i), i, src.length);
  });
  var right = new Array(Math.min(total - 1 - currIdx, 6 - left.length)).fill({}).map(function (_, i, src) {
    return renderIndicator(i + currIdx + 1, i, src.length);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center items-center"
  }, left, renderIndicator(currIdx, left.length, 7), right);
};

exports.Indicator = Indicator;

var GalleryCleanup = function GalleryCleanup(_ref5) {
  var onComplete = _ref5.onComplete;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(BaseBody, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-full flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_LottieAnimate["default"], {
    className: "w-1/3 lg:w-1/5",
    path: t('check.json'),
    onComplete: onComplete
  })));
};

exports.GalleryCleanup = GalleryCleanup;
var _default = BaseBody;
exports["default"] = _default;
//# sourceMappingURL=GalleryBody.js.map